export default __webpack_public_path__ + "fbe8f2c68c9f1450897e036bfb0850db.svg";